<template>
  <RouterLink
    data-testid="back-link"
    class="inline-flex flex-row items-center text-button-m text-main uppercase visited:text-main hover:text-primary"
    :to="props.to"
  >
    <SvgIcon :path="mdiChevronLeft" :size="16" class="mr-1" />

    <slot />
  </RouterLink>
</template>

<script setup lang="ts">
import { mdiChevronLeft } from '@mdi/js'
import type { RouteLocationRaw } from 'vue-router'

const props = defineProps<{
  to: RouteLocationRaw
}>()
</script>
